import { EXT_ENDPOINT } from 'consts/api';
import { debug, initXMLhttp } from 'helpers/helpers';
import { getAttachmentTransactionId } from 'helpers/socket';
import { ENGT_CHAT } from 'js/bot.model';
import { appendToChat } from 'js/conversation';

export function uploadFile(text) {
	const ref = this;
	const http = initXMLhttp();
	const payload = new FormData();
	this.fileUploadBtn = document.querySelector('#engtAttachmentInput');
	const [file] = this.fileUploadBtn?.files;
	if (!file || !ENGT_CHAT.get('attachmentTransactionId')) {
		ref.stopLoader();
		return;
	}

	payload.append('file', file);
	payload.append('workflow', 'BOT_V2_ATTACHMENT');
	payload.append('application', 'engati-bot-v2');

	try {
		http.open('POST', EXT_ENDPOINT().ATTACHMENTS, true);
		http.setRequestHeader('transactionId', ENGT_CHAT.get('attachmentTransactionId') || '');
		http.setRequestHeader('timeStamp', new Date().getTime());
		http.setRequestHeader(
			'customInfo',
			JSON.stringify({
				user_id: ENGT_CHAT.get('status.sessionKey'),
				bot_ref: parseInt(ENGT_CHAT.get('config.botRef')),
			})
		);
		http.onreadystatechange = function () {
			let respJson;
			try {
				respJson = JSON.parse(http.responseText);
			} catch (e) {
				respJson = http.responseText;
			}

			if (this.readyState === 4 && this.status === 200) {
				if (respJson?.status?.code === 1000) {
					ref.closeModal();
					sendFileViaSocket.call(ref, respJson, text);
					getAttachmentTransactionId();
				} else {
					let errorMessage;

					if (respJson?.status?.code === 28009) {
						errorMessage = 'File not supported';
					} else if (respJson?.status?.code === 28010) {
						errorMessage = 'Invalid File Size, size limit is 25MB!';
					} else {
						errorMessage = 'File not supported';
					}

					ref.html.querySelector('.engt-upload-error').innerText = errorMessage;
					ref.stopLoader();
					debug(`File upload error -> ${respJson} >> data >> ${ref.data}`);
				}
			}
		};
		http.send(payload);
	} catch (error) {
		ref.stopLoader();
		debug(`File upload error -> ${error} >> data >> ${ref.data}`);
	}
}

function sendFileViaSocket(resp, text) {
	const [file] = this.fileUploadBtn?.files;
	const { url, name, mimeType, token, size } = resp?.responseObject || {};
	let type = 'file';
	if (file.type.indexOf('image') > -1) {
		type = 'image';
	} else if (file.type.indexOf('audio') > -1) {
		type = 'audio';
	}

	const dataPacket = {
		type: 'file',
		url,
		name,
		transaction_id: null,
		mime_type: mimeType,
		token,
		message_text: text,
	};
	const packetToView = {
		session_id: '',
		message_id: '',
		message: {
			data:
				type === 'image'
					? {
							alt_text: name,
							image_url: url,
							message_text: text,
					  }
					: {
							file_size: size,
							file_name: name,
							alt_text: name,
							file_url: url,
							message_text: text,
							...(type === 'audio' && { audio_url: url }),
					  },
			type,
			sender: 'user',
		},
		messageToBeDisplayed: text || name,
		sender: 'user',
		timestamp: new Date().getTime(),
	};

	ENGT_CHAT.get('sendMessage')(text || name, { message: dataPacket, skipAppendToDom: true });
	appendToChat(packetToView, {
		storeMsgInLs: true,
		isOldMessage: false,
	});
}
